"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ActivityUsers = _interopRequireDefault(require("./components/ActivityUsers.vue"));
var _enums = require("./enums");
var _lotteryAssistant = require("@/api/lotteryAssistant");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _clipboard = _interopRequireDefault(require("clipboard"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 权限判断函数

var tableFroms = {
  page: 1,
  limit: $constants.page.limit[0],
  keywords: '',
  activityType: '',
  activityStyle: '',
  status: ''
};
var _default = exports.default = {
  name: 'ActivityList',
  components: {
    ActivityUsers: _ActivityUsers.default
  },
  data: function data() {
    return {
      listLoading: false,
      keywords: '',
      activityType: '',
      activityStyle: '',
      typeOptions: _enums.typeOptions,
      styleOptions: _enums.styleOptions,
      statusOptions: [{
        label: '未开始',
        value: 1
      }, {
        label: '进行中',
        value: 2
      }, {
        label: '已结束',
        value: 3
      }],
      tableKey: 0,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: Object.assign({}, tableFroms),
      activityUser: {
        show: false,
        id: '',
        type: 'edit'
      }
    };
  },
  computed: {},
  watch: {
    'activityUser.show': {
      handler: function handler() {
        if (!this.activityUser.show) {
          this.getList();
        }
      }
    }
  },
  activated: function activated() {
    this.handleSearchList();
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:lottery-assistant:activity:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //添加商品
    handleAdd: function handleAdd() {
      //id:商品id，isDisabled：是否能编辑(noEdit不能，edit能)，isChoose：是否是选择商品(choose是，noChoose不是)
      this.$router.push({
        path: "/marketing/lottery-assistant/activity/createActivity/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/lottery-assistant/activity/createActivity/".concat(row.activityId, "/").concat(operate)
      });
    },
    handleActivityUser: function handleActivityUser(row, type) {
      var _this = this;
      this.activityUser.id = row.activityId;
      this.activityUser.type = type;
      this.$nextTick(function () {
        _this.activityUser.show = true;
      });
    },
    handleDrawRun: function handleDrawRun(row) {
      var _this2 = this;
      this.$modal.confirm('是否立即开奖？').then(function () {
        _this2.listLoading = true;
        return (0, _lotteryAssistant.lotteryActivityRecordDrawApi)({
          id: row.activityId
        });
      }).then(function () {
        _this2.getList();
        _this2.$modal.msgSuccess('开奖成功');
      }).catch(function () {}).finally(function () {
        _this2.listLoading = false;
      });
    },
    handleSearchList: function handleSearchList() {
      this.getList(1);
    },
    //重置
    handleReset: function handleReset() {
      this.tableFrom.keywords = '';
      this.tableFrom.activityType = '';
      this.tableFrom.activityStyle = '';
      this.tableFrom.status = '';
      this.keywords = '';
      this.activityType = '';
      this.activityStyle = '';
      this.timeVal = [];
      this.handleSearchList();
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = this.keywords;
      this.tableFrom.activityType = this.activityType;
      this.tableFrom.activityStyle = this.activityStyle;
      (0, _lotteryAssistant.activityListApi)(this.tableFrom).then(function (data) {
        var list = (data.list || []).map(function (item) {
          item.sortTmp = item.sort;
          return item;
        });
        _this3.tableData.data = list;
        _this3.tableData.total = data.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handleCopy: function handleCopy() {
      var _this4 = this;
      this.$nextTick(function () {
        var clipboard = new _clipboard.default('.copy-data');
        clipboard.on('success', function () {
          _this4.$message.success('复制成功');
          clipboard.destroy();
        });
      });
    },
    //修改首页状态
    handleIndexFlagChange: function handleIndexFlagChange(row) {
      var _this5 = this;
      var params = {
        id: row.activityId,
        indexFlag: row.indexFlag
      };
      (0, _lotteryAssistant.activitySetIndexFlagApi)(params).then(function (res) {
        _this5.$message.success('更新状态成功');
      }).catch(function () {
        _this5.$message.error('更新状态失败');
        row.indexFlag = row.indexFlag ? 0 : 1;
      });
    },
    handleSort: function handleSort(row, index) {
      var _this6 = this;
      if (row.sortTmp !== row.sort) {
        this.loading = true;
        var params = {
          activityId: row.activityId,
          sort: row.sortTmp
        };
        (0, _lotteryAssistant.activityUpdateSortApi)(params).then(function () {
          row.sort = row.sortTmp;
          _this6.$message.success('更新成功');
        }).catch(function (err) {
          row.sortTmp = row.sort;
          _this6.$message.error('更新失败');
        }).finally(function () {
          _this6.loading = false;
        });
      }
    },
    formatter: function formatter(value, key) {
      if (key === 'activityStyle') {
        var target = this.styleOptions.find(function (item) {
          return item.value === value;
        });
        return target ? target.label : value;
      }
      if (key === 'status') {
        var _target = this.statusOptions.find(function (item) {
          return item.value === value;
        });
        return _target ? _target.label : value;
      }
      if (key === 'winConfig') {
        return value === 1 ? '未配置' : '已配置';
      }
      return '-';
    }
  }
};